import React from "react";
import PropTypes from "prop-types";
import "./Events.css";
import Eventpic from "./Eventpic";
import EventDetails from "./EventDetailsData";
import { Carousel } from "react-responsive-carousel";

const Events = () => {
  return (
    <div className="flex event-container">
      {/* recommended video */}
      {/* {window.screen.availWidth > 800 ? (
        <div className="recommendeVideos">
          <h3 style={{ textAlign: "center" }}>RECOMMENDED VIDEOS</h3>
          <br></br>
          <div>
            {youtubeLinks.map((sLink, i) => (
              <div className="Video" style={{ position: "relative" }} key={i}>
                <a
                  style={{ position: "absolute", right: "2px", bottom: "2px" }}
                  href={sLink}
                  target="_blank"
                >
                  <img
                    src={"/image/Link.png"}
                    alt=""
                    style={{ height: "30px", width: "30px" }}
                  />
                </a>
                <iframe title="myFrame" width="250" height="140" src={sLink} />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div></div>
      )} */}

      {/* recommended video ends */}

      <div className="line">
        <div style={{ position: "relative" }}>
          {/* event pics */}
          <h1
            className="hs my-7"
            style={{
              zIndex: 100,
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              top: "15px",
              width: "100%",
              fontWeight: "bold",
              fontSize: "35px",
              backgroundColor: "rgba(0,0,0,0.1)",
              lineHeight: "70px",
            }}
          >
            आयोजित प्रतियोगिताएं
          </h1>
          {/* <div
            style={{
              height: "550px",
              width: "100%",
              overflow: "hidden",
              position: "absolute",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                background: "linear-gradient(to bottom,rgba(0,0,0,0),white)",
                zIndex: 90,
              }}
            ></div>
            <Carousel
              className="w-full"
              infiniteLoop={true}
              showIndicators={false}
              showStatus={false}
              autoPlay={true}
              interval={2000}
              transitionTime={400}
            >
              {Eventpic.map((slide, i) => (
                <div
                  key={i}
                  style={{
                    height: "550px",
                    width: "100%",
                    margin: "auto",
                    position: "relative",
                  }}
                >
                  <img
                    className="rounded"
                    alt=""
                    src={slide.image}
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
            </Carousel>
          </div> */}
          <div
            style={{
              display: "flex",
              zIndex: 100,
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-evenly",
              paddingTop: "170px",
            }}
          >
            {EventDetails.map((sdata, i) => (
              <div
                key={i}
                style={{
                  position: "relative",
                  zIndex: 120,
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "20px",
                  width: "16rem",
                  textAlign: "center",
                }}
                className="outerDivEvent size w-64 h-80 bg-white shadow-md m-5 flex flex-col overflow-hidden  text-center transform transition duration-500 "
              >
                <div
                  style={{ position: "absolute" }}
                  className="event-thumbnail h-full w-64"
                >
                  <img src={sdata.image} className="w-screen h-full" alt="" />
                </div>
                {/* <div style={{flex:1,}}></div> */}
                <div
                  className="m-0 p-0 eventHiddenContent"
                  style={{
                    margin: "0px",
                    padding: "7px",
                    height: "400px",
                    display: "flex",
                    textAlign: "center",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    paddingHorizontal: "10px",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    zIndex: 50,
                    alignItems: "center",
                    paddingLeft: "15px",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      color: "#eb7a34",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    {" "}
                    {sdata.title}
                  </div>
                  {/* <span style={{ color: "white", fontSize: "10px" }}>
                    {sdata.date}
                  </span> */}
                  <p
                    className="py-1 normal-case"
                    style={{
                      paddingTop: "0.25rem" /* 4px */,
                      paddingBottom: "0.25rem",
                      fontSize: "15px",
                      color: "rgba(230,230,230,0.85)",
                    }}
                  >
                    {sdata.detailshort}
                    <a
                      href={"/event_information?name=" + sdata.name}
                      target="_blank"
                      style={{ color: "#3279a8" }}
                    >
                      अधिक जानें
                    </a>
                  </p>
                </div>
              </div>
            ))}
          </div>
          {/* kavi ends */}
        </div>
      </div>
    </div>
  );
};
Events.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  homePageReducer: PropTypes.object.isRequired,
};

export default Events;
